import React from 'react';
import {AssetUploadProvider} from '../Context/Upload/UploadContext';
import UploadFromDevice from '../AssetServices/UploadFromDevice/UploadFromDevice';

const AssistantView = () => {
  return (
    <AssetUploadProvider>
      <UploadFromDevice />
    </AssetUploadProvider>
  );
};

export default AssistantView;
